export const FEED_TAB_IDS = {
  posts: 'posts',
  followers: 'followers',
};

export const FEED_TABS = [
  { id: FEED_TAB_IDS.posts, label: 'Posts' },
  { id: FEED_TAB_IDS.followers, label: 'Followers' },
];

export default FEED_TABS;
